import Vue from "vue";

Vue.component("PreviewImage", () => import("./PreviewImage.vue"));

Vue.component("ImageDropzone", () => import("./ImageDropzone.vue"));

Vue.component("ImageDropzonePublication", () =>
  import("./ImageDropzonePublication.vue")
);
